// Formats a sourcing run's `imported_at` for the RunTabs record bar
// (BRAND-9515 Idea-2 rework). Mirrors the existing
// AgentSourcedCreatorDrawer/SelectedWorks `formatDate` convention: missing or
// unparseable input renders an em dash rather than throwing or showing
// "Invalid Date".
export const formatImportedAt = (iso: string | null | undefined): string => {
  if (!iso) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  return d.toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' })
}
